/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';

import { ImageWithFallback } from 'sarsaparilla';
import { INTERAGENCY_PASSES_MAP } from '../constants';

export default function PassImage({ type }) {
    const interAgencyPass = INTERAGENCY_PASSES_MAP[type];
    const filename = interAgencyPass?.fileName ?? '';
    const fallbackExtension = interAgencyPass?.fallbackExtension ?? 'jpg';
    const altText = interAgencyPass?.altText ?? 'pass card';

    if (!interAgencyPass) {
        return null;
    }

    return (
        <ImageWithFallback
            alt={altText}
            imagePath={`${process.env.CDN}/img/interagencyPass/${filename}`}
            fallbackExtension={fallbackExtension}
        />
    );
}

PassImage.propTypes = {
    type: PropTypes.string,
};
